const formatPhone = (value?: string): string => {
  if (!value) return '';

  // if it is formatted 1.1234567890
  const [countryCode, number] =
    value.indexOf('.') < 0 ? ['1', value] : value.split('.');
  if (countryCode === '1') {
    return `(${number.substring(0, 3).trim()}) ${number
      .substring(3, 6)
      .trim()}-${number.substring(6).trim()}`;
  }

  return `+${countryCode} ${number}`;
};

export default formatPhone;
